// needs to be a function as window.GO_API_URL
// might be initialized before the window object is injected
/**
 * from meta tags in app.config.ts
 */
export const getApiConfig = () => ({
  globalSearch: {
    autocompleteUrl: `${window.GO_API_URL}/global-search-alt`,
    url: `${window.GO_API_URL}/global-search`,
  },
})
